/**
 * Helper padrão de resposta do sistema
 * Utilizar em todos os controllers
 *
 * Estrutura padrão:
 * {
 *   type: "success" | "info" | "warning" | "error",
 *   message: string,
 *   code?: string,
 *   resultado?: any,
 *   meta?: any
 * }
 */

const ok = (res, { type = 'success', message = '', code = null, resultado = null, meta = null } = {}) => {
    return res.status(200).json({
        type,
        message,
        code,
        resultado,
        meta,
    });
};

const created = (res, { message = 'Registro criado com sucesso.', code = null, resultado = null, meta = null } = {}) => {
    return res.status(201).json({
        type: 'success',
        message,
        code,
        resultado,
        meta,
    });
};

const warning = (res, { message = 'Atenção.', code = 'WARNING', resultado = null } = {}) => {
    return res.status(200).json({
        type: 'warning',
        message,
        code,
        resultado,
    });
};

const info = (res, { message = '', code = null, resultado = null } = {}) => {
    return res.status(200).json({
        type: 'info',
        message,
        code,
        resultado,
    });
};

const fail = (res, status = 500, { message = 'Erro interno do servidor.', code = null, resultado = null } = {}) => {
    return res.status(status).json({
        type: 'error',
        message,
        code,
        resultado,
    });
};

export { ok, created, warning, info, fail };
